import * as PIXI from "pixi.js";
import WebfontLoaderPlugin from "pixi-webfont-loader";
window.PIXI = PIXI;

PIXI.Loader.registerPlugin(WebfontLoaderPlugin);
export default PIXI;
